import axios from 'axios';

// Public storefront API — no auth token attached. Prices are never returned here.
const SITE = axios.create({ baseURL: '/api/site', timeout: 20000 });

export default SITE;

// Apply the editable brand theme (from site_content) as CSS variables.
export function applyTheme(content) {
  const root = document.documentElement;
  const set = (v, fallback) => content[v] || fallback;
  root.style.setProperty('--sf-primary',     set('theme.primary', '#191919'));
  root.style.setProperty('--sf-primary-dark', set('theme.primary_dark', '#000000'));
  root.style.setProperty('--sf-accent',      set('theme.accent', '#85cde9'));
  root.style.setProperty('--sf-hover',       set('theme.hover', set('theme.accent', '#85cde9')));
  root.style.setProperty('--sf-body-bg',     set('theme.body_bg', '#f7f8fa'));
  root.style.setProperty('--sf-muted',       set('theme.muted', '#888888'));
}
